import Loadable from 'react-loadable';
import Loader from '../Loader/Loader';

const LoadableComponent = opts => {
    return Loadable(Object.assign({
        loading: Loader,
        delay: 200,
        timeout: 20,
    }, opts))
};

export default LoadableComponent;



// WEBPACK FOOTER //
// ./src/components/hoc/LoadableComponent.js